import React from 'react';

const Dummy = () => {
    return (
        <div className="dummy"></div>
    );
}

export default Dummy;